"use client";

import type { GetProductPricePromise } from "@/features/products/dal";
import { SalesTag } from "@/features/products/ProductCard/ProductTags";
import { use } from "react";
import styles from "./index.module.css";

type SaleTagProps = {
	pricePromise: GetProductPricePromise;
};

export const UnsuspendedSaleTag = ({ pricePromise }: SaleTagProps) => {
	const price = use(pricePromise);
	const { priceBeforeDiscountAsNumber, priceAsNumber, discountPercent } = price;

	const onSale =
		priceBeforeDiscountAsNumber && priceAsNumber
			? priceBeforeDiscountAsNumber > priceAsNumber
			: false;

	if (!onSale) return null;

	return (
		<SalesTag
			className={styles.saleTag}
			size="small"
			onSale={onSale}
			discountPercent={discountPercent}
		/>
	);
};
